import React from "react";
var TabPanel = function TabPanel(_ref) {
  var children = _ref.children,
    _ref$contentStyles = _ref.contentStyles,
    contentStyles = _ref$contentStyles === void 0 ? {
      display: 'flex',
      marginTop: '20px'
    } : _ref$contentStyles,
    contentClass = _ref.contentClass,
    tabID = _ref.tabID;
  return /*#__PURE__*/React.createElement("div", {
    className: contentClass,
    "data-tab-content": tabID,
    style: contentStyles
  }, children);
};
export default TabPanel;